function InicioCompo() {


  return (
    <>
      <div className="full-width-image">
        <div className="izquierdaBanner">
          <div className="imagenIzquierdaComtenedor">
            <img src="./img/Inicio/icoWifi.png" />
          </div>
          <div className="textoContenedorIzquierda">
            <div className="textoIz1">
              <p>Speedy Fibra</p>
            </div>
            <div className="textoIz2">
              <p>La fibra que todos quieren</p>
            </div>
          </div>
        </div>
        <div className="centralBanner">
        </div>
        <div className="derechaBanner">
          <div className="textoDer1">
            <p>200 Megas</p>
          </div>
          <div className="textoDer2">
            <p>$22.50/mes</p>
          </div>
          <div className="textoDer3">
            <p>Contrátalo ahora</p>
          </div>
          <a href="#" class="button-link">Revisa tu cobertura</a>
        </div>
      </div>
      <div class="link-container">
        <a href="./#" class="link medios">
          <img src="./img/Inicio/internethogaractive.svg" alt="Imagen 1" />
          Internet Hogar
        </a>
        <a href="./corporativo" class="link medios dos">
          <img src="./img/Inicio/internet2.svg" alt="Imagen 2" />
         Internet Corporativo
        </a>
        <a href="./streaming" class="link medios tres">
          <img src="./img/Inicio/internet4.png" alt="Imagen 3" />
          Streaming
        </a>
        <a href="./dual" class="link ultimo">
          <img src="./img/Inicio/internet3.png" alt="Imagen 4" />
          Dual Pack
        </a>
      </div>
      <div className="texto arriba">
        Internet Hogar Fibra Óptica
      </div>
      <div className="texto abajo">
        Mejor experiencia de internet con más velocidad y estabilidad
      </div>
      <div className="planesContenedor">
        <div className="planUno">
          <div className="espacioUltima"></div>
          <div className="primeraFila">
            <div className="normal">Internet</div><div className="negrita">Fibra</div>
          </div>
          <div className="primeraFila"><div className="negrita">200 Megas</div></div><br/>
          <div className="primeraFila"><div className="precio">$22.50/mes</div></div><br/>
          <div className="capsulaPlan"><div className="capsulaColor">25% dcto.</div><div className="capsulaSinColor"> Oferta Online</div></div><br/>
          <div className="primeraFila">Por 4 meses, luego<div className="negritaPeque">$30.00/mes</div><br /></div><br />
          <div className="primeraFila"><img src="./img/Planes/iconoPlanes1y3.png" />Router 4 antenas WI-FI 6</div><br />
          <div className="contenedorLoQuiero"><div className="capsulaQuiero"><a>Lo quiero</a></div></div><br />
          <div className="primeraFila"><img src="./img/Planes/iconoPlanes2.png" />Velocidad simétrica <br /></div>
          <div className="primeraFila masEspacio"><p>Hasta <strong>200 Mbps</strong> de subida</p><br /></div>
          <div className="primeraFila masEspacio">y bajada</div>
          <div className="espacioUltima"></div>
          <div className="lineaHorizontal" />
          <div className="primeraFila espacio"><img src="./img/Planes/iconoPlanes1y3.png" />Router principal  <div className="negritaPeque">incluido</div> <br /></div>
          <div className="lineaHorizontal" /> 
          <div className="primeraFila espacio"><img src="./img/Planes/iconoPlanes4.png" />Costo de instalación <div className="negritaPeque">$0</div></div>
        </div>
        <div className="planDos">
          <div className="espacioUltima"></div>
          <div className="primeraFila">
            <div className="normal">Internet</div><div className="negrita">Fibra</div> <br />
          </div>
          <div className="primeraFila"><div className="negrita">250 Megas</div></div><br/>
          <div className="primeraFila"><div className="precio">$25.20/mes</div></div><br/>
          <div className="capsulaPlan"><div className="capsulaColor">25% dcto.</div><div className="capsulaSinColor"> Oferta Online</div></div><br/>
          <div className="primeraFila">Por 4 meses, luego<div className="negritaPeque">$33.60/mes</div><br /></div><br />
          <div className="primeraFila"><img src="./img/Planes/iconoPlanes1y3.png" />Router 4 antenas WI-FI 6</div><br />
          <div className="contenedorLoQuiero"><div className="capsulaQuiero"><a>Lo quiero</a></div></div><br />
          <div className="primeraFila"><img src="./img/Planes/iconoPlanes2.png" />Velocidad simétrica <br /></div>
          <div className="primeraFila masEspacio"><p>Hasta <strong>250Mbps</strong> de subida</p><br /></div>
          <div className="primeraFila masEspacio">y bajada</div>
          <div className="espacioUltima"></div>
          <div className="lineaHorizontal" />
          <div className="primeraFila espacio"><img src="./img/Planes/iconoPlanes1y3.png" />Router principal  <div className="negritaPeque">incluido</div> <br /></div>
          <div className="lineaHorizontal" />
          <div className="primeraFila espacio"><img src="./img/Planes/iconoPlanes4.png" />Costo de instalación <div className="negritaPeque">$0</div></div>
        </div>
        <div className="planTres">
          <div className="espacioUltima"></div>
          <div className="primeraFila">
            <div className="normal">Internet</div><div className="negrita">Fibra</div> <br />
          </div>
          <div className="primeraFila"><div className="negrita">275 Megas</div></div><br/>
          <div className="primeraFila"><div className="precio">$26.25/mes</div></div><br/>
          <div className="capsulaPlan"><div className="capsulaColor">25% dcto.</div><div className="capsulaSinColor"> Oferta Online</div></div><br/>
          <div className="primeraFila">Por 4 meses, luego<div className="negritaPeque">$35.00/mes</div><br /></div><br />
          <div className="primeraFila"><img src="./img/Planes/iconoPlanes1y3.png" />Router 4 antenas WI-FI 6</div><br />
          <div className="contenedorLoQuiero"><div className="capsulaQuiero"><a>Lo quiero</a></div></div><br />
          <div className="primeraFila"><img src="./img/Planes/iconoPlanes2.png" />Velocidad simétrica <br /></div>
          <div className="primeraFila masEspacio"><p>Hasta <strong>275Mbps</strong> de subida</p><br /></div>
          <div className="primeraFila masEspacio">y bajada</div>
          <div className="espacioUltima"></div>
          <div className="lineaHorizontal" />
          <div className="primeraFila espacio"><img src="./img/Planes/iconoPlanes1y3.png" />Router principal  <div className="negritaPeque">incluido</div> <br /></div>
          <div className="lineaHorizontal" />
          <div className="primeraFila espacio"><img src="./img/Planes/iconoPlanes4.png" />Costo de instalación <div className="negritaPeque">$0</div></div>
        </div>
        <div className="planCuatro">
          <div className="espacioUltima"></div>
          <div className="primeraFila">
            <div className="normal">Internet</div><div className="negrita">Fibra</div> <br />
          </div>
          <div className="primeraFila"><div className="negrita">350 Megas</div></div><br/>
          <div className="primeraFila"><div className="precio">$31.50/mes</div></div><br/>
          <div className="capsulaPlan"><div className="capsulaColor">25% dcto.</div><div className="capsulaSinColor"> Oferta Online</div></div><br/>
          <div className="primeraFila">Por 4 meses, luego<div className="negritaPeque">$42.00/mes</div><br /></div><br />
          <div className="primeraFila"><img src="./img/Planes/iconoPlanes1y3.png" />Router 4 antenas WI-FI 6</div><br />
          <div className="contenedorLoQuiero"><div className="capsulaQuiero"><a>Lo quiero</a></div></div><br />
          <div className="primeraFila"><img src="./img/Planes/iconoPlanes2.png" />Velocidad simétrica <br /></div>
          <div className="primeraFila masEspacio"><p>Hasta <strong>350Mbps</strong> de subida</p><br /></div>
          <div className="primeraFila masEspacio">y bajada</div>
          <div className="espacioUltima"></div>
          <div className="lineaHorizontal" />
          <div className="primeraFila espacio"><img src="./img/Planes/iconoPlanes1y3.png" />Router principal  <div className="negritaPeque">incluido</div> <br /></div>
          <div className="lineaHorizontal" />
          <div className="primeraFila espacio"><img src="./img/Planes/iconoPlanes4.png" />Costo de instalación <div className="negritaPeque">$0</div></div>
        </div>
      </div>
    </>
  );
}

export default InicioCompo;
